import React, { useMemo } from "react";
import { isNumber } from "lodash";

import {
	ExecutorReport,
	Language,
} from "../../../../../../../../../../services";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (item: FeeCellContent.Props["item"]) => {
	if (!isNumber(item?.executorRate?.subscription)) return "";
	return formatNumber(item?.executorRate?.subscription);
};

const FeeCellContent: React.FC<FeeCellContent.Props> = ({ item }) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace FeeCellContent {
	interface Props {
		item: ExecutorReport.Model;
		language: Language;
	}
}

export default FeeCellContent;
